import React from "react";
import addressIllustrationLogo from "./AddressIllustrationLogo.svg";

function AddressIllustrationLogoIcon({
  alt = "Address illustration",
  className = "",
  height = 196,
  width = 189,
}) {
  return (
    <img
      alt={alt}
      className={className}
      height={height}
      src={addressIllustrationLogo}
      width={width}
    />
  );
}

export default AddressIllustrationLogoIcon;
